import { datadogRum } from '@datadog/browser-rum';

export const setDatadogProperty = (name: string, value: string) =>
  datadogRum.setUserProperty(name, value);

export const setDatadogAction = (name: string, value: any) =>
  datadogRum.addAction(name, value);
